import React, { useEffect, useState } from 'react';
import { PageShell } from '@/ui/PageShell';
import { withBase } from '@/ui/Header';

export type LegalDocument = { type: 'terms' | 'privacy'; lang: string; version: string; content: string; updatedAt: string };
export type LegalDocuments = Record<'terms' | 'privacy', LegalDocument>;
const ENDPOINT = 'https://innopagebox.com/meta/content/terms/public';

export function usePageboxLegal(enabled: boolean) {
    const [documents, setDocuments] = useState<LegalDocuments | null>(null);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!enabled) return;
        const controller = new AbortController();
        let active = true;
        const timeout = window.setTimeout(() => controller.abort(), 10000);
        setDocuments(null);
        setError(false);
        Promise.all((['terms', 'privacy'] as const).map(async type => {
            const response = await fetch(`${ENDPOINT}?type=${type}&lang=ko`, {
                signal: controller.signal, credentials: 'omit', cache: 'no-store',
            });
            if (!response.ok) throw new Error('Document unavailable');
            const doc = await response.json();
            if (doc.type !== type || doc.lang !== 'ko' || typeof doc.version !== 'string' || !doc.version.trim() ||
                typeof doc.content !== 'string' || !doc.content.trim()) throw new Error('Invalid document');
            return doc as LegalDocument;
        })).then(([terms, privacy]) => {
            if (active) setDocuments({ terms, privacy });
        }).catch(() => { if (active) setError(true); })
          .finally(() => window.clearTimeout(timeout));
        return () => { active = false; controller.abort(); window.clearTimeout(timeout); };
    }, [enabled, attempt]);
    return { documents, error, retry: () => setAttempt(value => value + 1) };
}

export function PageboxLegalViewer({ document, onClose, width, fontSize }: {
    document: LegalDocument; onClose: () => void; width: number | string; fontSize: number | string;
}) {
    const title = document.type === 'terms' ? '서비스 이용약관' : '개인정보처리방침';
    return <PageShell title={title} onBack={onClose} backIcon={withBase('icons/prev1.svg')} width={width}>
        <div style={{ padding: '24px 6%', fontSize, lineHeight: 1.7 }}>
            <div style={{ marginBottom: 20 }}>버전 {document.version}</div>
            <div style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{document.content}</div>
            <button type="button" onClick={onClose} style={{ display: 'block', margin: '32px auto', padding: '12px 32px', fontSize: 'inherit', background: '#fff', border: '1px solid #111', borderRadius: 8 }}>동의 화면으로 돌아가기</button>
        </div>
    </PageShell>;
}
